export default {"src":"/_next/static/media/rewind.d9d3ba92.svg","height":108,"width":536,"blurWidth":0,"blurHeight":0};